import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  KantongTersedia,
  PembatalanFilter,
  PembatalanForm,
  PembatalanKomponenDarah
} from "@/types/pembatalan_komponen_darah";

function tolak(err: any) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

async function getByRegister(register: string | number): Promise<PembatalanKomponenDarah[]> {
  const res = await http.getData(`/register/${register}/pembatalan-komponen-darah`).catch(tolak);
  return res.data.data;
}

async function kantongTersedia(
  register: string | number,
  kecuali: number | null
): Promise<KantongTersedia[]> {
  const res = await http
    .getDataParam(`/register/${register}/pembatalan-komponen-darah/kantong`, {
      params: { kecuali: kecuali || undefined }
    })
    .catch(tolak);
  return res.data.data;
}

async function simpan(register: string | number, form: PembatalanForm) {
  const payload = {
    register_id: register,
    dibatalkan_at: form.dibatalkan_at,
    alasan: form.alasan,
    ruang: form.ruang,
    kantong_ids: form.kantong_ids
  };
  const res = form.id
    ? await http.putData(`/pembatalan-komponen-darah/${form.id}`, payload).catch(tolak)
    : await http.postData("/pembatalan-komponen-darah", payload).catch(tolak);
  return res.data;
}

async function sign(id: number, password: string) {
  const res = await http
    .putData(`/pembatalan-komponen-darah/${id}/sign`, { password })
    .catch(tolak);
  return res.data;
}

async function destroy(id: number) {
  const res = await http.deleteData(`/pembatalan-komponen-darah/${id}`).catch(tolak);
  return res.data;
}

async function list(
  f: PembatalanFilter
): Promise<{ rows: PembatalanKomponenDarah[]; maks_baris: number }> {
  const res = await http
    .getDataParam("/pembatalan-komponen-darah", {
      params: {
        tgl_start: f.tgl_start || undefined,
        tgl_end: f.tgl_end || undefined,
        unit_id: f.unit_id || undefined,
        status: f.status || undefined,
        term: f.term || undefined
      }
    })
    .catch(tolak);
  return res.data.data;
}

async function count(): Promise<number> {
  const res = await http.getData("/pembatalan-komponen-darah/count");
  return res.data.data.diajukan;
}

async function terima(id: number) {
  const res = await http.putData(`/pembatalan-komponen-darah/${id}/terima`, {}).catch(tolak);
  return res.data;
}

async function tolakPembatalan(id: number, alasan: string) {
  const res = await http
    .putData(`/pembatalan-komponen-darah/${id}/tolak`, { alasan })
    .catch(tolak);
  return res.data;
}

export default {
  getByRegister,
  kantongTersedia,
  simpan,
  sign,
  destroy,
  list,
  count,
  terima,
  tolak: tolakPembatalan
};
